module.exports = __webpack_public_path__ + "static/bg-verde-3ae97c43f22e0d5c0797343e92c1daff.jpg";